import type { RouterConfig } from "@nuxt/schema";

/**
 * Toda navegação começa no topo da tela.
 *
 * O coletor tem tela pequena e o menu costuma estar rolado quando o operador
 * escolhe a rotina. Sem isto a tela de destino herdava a rolagem do menu e
 * abria "em branco" — os campos existiam, só estavam acima da área visível, e
 * o operador precisava rolar para cima para descobrir isso. Foi o que
 * aconteceu ao entrar na Convocação Ativa.
 *
 * O `savedPosition` é ignorado de propósito, inclusive no voltar: numa rotina
 * de coletor o primeiro campo é sempre o que interessa, e restaurar a posição
 * anterior reproduziria exatamente o sintoma.
 */
export default <RouterConfig>{
	/**
	 * Rotas adicionadas manualmente quando a tela não possui código de rotina.
	 * O acompanhamento por curva é uma tela nova, ainda sem numeração no menu.
	 */
	routes: (routes) => [
		...routes,
		{
			name: "acompanhamento-estoque-curva-financeira",
			path: "/acompanhamento/estoque-curva-financeira",
			meta: { layout: "default" },
			component: () => import("~/pages/acompanhamento/estoque-curva-financeira.vue"),
		},
	],
	scrollBehavior(to) {
		// Âncora explícita continua valendo — é pedido do próprio link.
		if (to.hash) {
			return { el: to.hash, top: 0 };
		}

		return { left: 0, top: 0 };
	},
};
